module.exports = __webpack_public_path__ + "media/images/icons/step-arrow-54b4cd0d15a9039809749fee9ee28a4e.svg";